<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <SHBudgetManageDiv :popupVisible="popupVisible" @popupClose="popupClose" title="안전보건 예산 양식 관리" />
    <v-sheet class="contents-container">
      <i-card-vertical
        headerTitle="안전보건 예산 관리"
        device="web"
        :IsUseInnerAddition="true"
        :IsUseEditorBox="true"
      >
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="startDate"
            :dateOnly="true"
            class="mx-1"
            label="조회년도"
            max-width="300px"
            year
            no-title
            style="max-width: 340px"
            @getDate="handleDateChange"
          ></date-bar>
        </template>
        <template v-slot:innerAddition>
          <!-- 개발 완료 때 까지 주석 -->
          <!-- <v-btn color="primary" large elevation="0" outlined class="rounded ml-2" @click="btnPopup">안전보건 예산 양식 관리</v-btn> -->
        </template>
        <template v-slot:body>
          <!-- table -->
          <table class="tg mt-3">
            <thead>
              <tr>
                <th class="tg-vs2s">구분</th>
                <th class="tg-vs2s">구분별 항목</th>
                <th class="tg-vs2s" style="width:20%;">예산(단위: 백만원)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(groupedItem, index) in groupedBudgetItems">
                <tr
                  v-for="(item, itemIndex) in groupedItem.items"
                  :key="'group-' + index + '-row-' + itemIndex"
                >
                  <td
                    class="tg-vs2s"
                    v-if="itemIndex === 0"
                    :rowspan="groupedItem.items.length"
                  >{{ groupedItem.budgetDivNm }}</td>
                  <td class="tg-0lax">{{ item.budgetDivItemNm }}</td>
                  <td class="tg-0lax">
                    <v-form ref="form">
                      <div class="centered-text-field">
                        <v-text-field
                          v-model.number="item.budget"
                          height="30px"
                          solo
                          :rules="[rules.numCheck]"
                          hide-details="auto"
                          placeholder="금액을 입력해주세요."
                          prefix="￦"
                          class="right-aligned"
                          @input="formatToKoreanWon(item,$event)"
                        />
                      </div>
                    </v-form>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="true" :subTitle="'절차서'" :pageTitle="'LeaderShip'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          headerTitle="안전보건 예산 관리"
          :useBtnList="buttonUseList1"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave()"
          @btnPrint="btnPrint"
        ></i-card-right>
        <!-- </v-card> -->
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import { getCurrentDate, getPreMonth, getYearFormat } from '@/utils/common.js'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import dateBar from '@/components/common/dateBar.vue'
import SHBudgetManageDiv from '@/views/leaderShip/SHBudgetManageDiv.vue'
import { getSHBudgetList, saveSHBudget } from '@/api/leaderShip/shbudgetManage'
import { AesDecrypt } from '@/utils/aes256'
import { getRptSHBudgetManage } from '@/api/leaderShip/rptSHBudgetManage'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'date-bar': dateBar,
    'i-card-vertical': iCardVertical,
    SHBudgetManageDiv,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      initCompId: '',
      compId: '',
      menu: false,
      allMode: 'allPages',
      dxDataGridRef: 'dxDataGrid',
      gridMain: [],
      buttonUseList1: [
        'btnSearch', //조회
        // 'btnAdd', // 추가
        'btnSave', // 삭제
        'btnPrint' // 출력
      ],
      numFormat: /^\d{1,3}(,\d{3})*(\.\d+)?$/,
      rules: {
        numCheck: value => !(value != null && value != '' && value.match(this.numFormat) == null) || this.$t('올바르지 않은 형식입니다.')
      },
      startDate: getPreMonth(0),
      searchStartDate: getYearFormat(getPreMonth(0)),
      budgetItem: [],
      clntId: '',
      dataDiv: '',
      preview: '',
      popupVisible: false,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  watch: {},
  computed: {
    mobileTrigger: function() {
      return this.getWidth() < 800
    },
    groupedBudgetItems() {
      // 중복된 budgetDivNm을 기준으로 그룹화하고 합친 데이터를 반환
      const groupedItems = {}
      this.budgetItem.forEach(item => {
        if (!groupedItems[item.budgetDivNm]) {
          groupedItems[item.budgetDivNm] = {
            budgetDivNm: item.budgetDivNm,
            items: []
          }
        }
        groupedItems[item.budgetDivNm].items.push(item)
      })
      return Object.values(groupedItems)
    }
  },

  created() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  methods: {
    btnSearch(isNotify) {
      const params = { clntId: this.getClntId(), compId: this.initCompId, writeYear: this.searchStartDate, targetId: '', targetType: '' }
      return new Promise((resolve, reject) => {
        this.budgetItem = []
        this.openLoading()

        getSHBudgetList(params, true)
          .then(res => {
            if (res.success) {
              this.budgetItem = res.list
              this.endLoading()
            }
          })
          .catch(e => {
            this.endLoading()
          })
          .finally(() => {})
      })
    },
    btnSave() {
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        async current => {
          this.openLoading()
          let saveData = []
          this.budgetItem.forEach(item => {
            item.clntId = this.getClntId()
            item.compId = this.initCompId
            item.dataClntId = 'COMMON'
            item.dataCompId = 'COMMON'
            item.writeYear = this.searchStartDate
            saveData.push(item)
          })
          saveSHBudget(saveData, true)
            .then(response => {
              this.btnSearch(true)
            })
            .catch(error => {
              if (error.response && error.response.data) {
                if (error.response.data.code == -2001) {
                  this.vToastify(this.$t(error.response.data.msg), 'info')
                }
              }
              this.endLoading()
            })
            .finally(res => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    handleDateChange(val) {
      if (val) {
        this.searchStartDate = val
      }
      this.btnSearch(true)
    },
    btnPrint(type) {
      let searchParams = {
        clntId: this.getClntId(),
        compId: this.initCompId,
        writeYear: this.searchStartDate
      }
      let params = {
        budgetVO: searchParams,
        type: type
      }
      this.openLoading()
      //PDF 출력
      getRptSHBudgetManage(params)
        .then(res => {
          this.downloadReport(res)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
      //window.open(new createObjectURL(blob),"_blank")
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    formatToKoreanWon(item, value) {
      // 문자열을 숫자로 파싱하여 한국 원 단위로 포맷팅
      const numberValue = parseFloat(value.replace(/,/g, ''))
      if (!isNaN(numberValue)) {
        item.budget = numberValue.toLocaleString('ko-KR')
      }
    },
    downloadReport(res) {
      let link = document.createElement('a')
      // 객체를 만들어서 생성
      let objectUrl = window.URL.createObjectURL(res.data)
      link.href = objectUrl
      link.download = res.headers.filename
      link.click()
    },
    btnPopup() {
      this.popupVisible = true
    },
    popupClose() {
      this.popupVisible = false
    }
  }
}
</script>

<style lang="scss">
.tg {
  border-collapse: collapse;
  width: 100%;
  // border-spacing: 0;
  border-color: #e0e0e0;
}

.tg th {
  font-size: 0.875rem;
  font-weight: 600;
  padding: 6px 0px;
  background-color: #f4f5f6;
  border-top: 1px solid #e0e0e0;
  &:not(:last-child) {
    border-right: 1px solid #e0e0e0;
  }
}

.tg td {
  font-size: 1rem;
  padding: 0px 20px;
  background-color: #ffffff;
  line-height: 41px; /* 행간을 중앙 정렬하려면 행의 높이와 같게 설정합니다. */
  vertical-align: middle; /* 텍스트를 세로 가운데로 정렬합니다. */
  border-top: 1px solid #e0e0e0;
  &:not(:last-child) {
    border-right: 1px solid #e0e0e0;
  }
}

.tg .tg-vs2s {
  text-align: center;
  vertical-align: middle;
}

.tg .tg-0lax {
  text-align: left;
  // display: flex;
  // align-items: center;
}
.tg tr:last-child td {
  border-bottom: 1px solid #e0e0e0;
}

.right-aligned >>> input {
  text-align: right; /* 입력 필드 내용을 오른쪽으로 정렬 */
}
.centered-text-field {
  display: flex;
  justify-content: center; /* 수평 중앙 정렬 */
  align-items: center; /* 수직 중앙 정렬 */
}
</style>
